"use client";

import clsx from "clsx";
import { type ReactNode } from "react";
import { LinkWithChannel } from "@/ui/atoms/link-with-channel";
import useSelectedPathname from "@/hooks/use-selected-pathname";

export function NavLink({ href, children }: { href: string; children: ReactNode }) {
	const pathname = useSelectedPathname();
	const isActive = pathname === href;
	const isPrimaryPath = href === "/peptides";

	return (
		<li className="inline-flex">
			<LinkWithChannel
				href={href}
				className={clsx(
					"text-[13px] font-medium tracking-[0.01em] transition-colors duration-150",
					isPrimaryPath && !isActive && "rounded-md px-3 py-1.5 text-foreground hover:bg-muted",
					isActive
						? "border-b border-primary pb-0.5 text-foreground"
						: "text-muted-foreground hover:text-foreground",
				)}
			>
				{children}
			</LinkWithChannel>
		</li>
	);
}
